import {on, addClass, removeClass, hasClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    element: ".js-scroll-functions",
}

export function init () {
    onFind(selectors.element, function (element) {
        let offset = 500;

        if(element.dataset.scrollOffset) {
            offset = element.dataset.scrollOffset;
        }

        on('scroll', function(evt) {
            if(window.scrollY >= offset) {
                addClass("shown", element);
            } else {
                if(hasClass("shown", element)) {
                    removeClass("shown", element);
                }
            }
        }, window);
    });
}